import React, { useEffect, useState } from "react";
import cancelImg from "../../images/cancel.svg";
import errorIcon from "../../images/error-icon.svg";
import "./ErrorHandler.css";

interface IProps {
  errorHandlerObj: {
    hasError: boolean;
    message: string;
  };
  className?: string;
}

const ErrorHandler: React.FC<IProps> = function ({
  errorHandlerObj,
  className,
}) {
  const [dismissedMessage, setDismissedMessage] = useState("");

  useEffect(() => {
    if (errorHandlerObj.hasError && errorHandlerObj.message) {
      setDismissedMessage("");
    }
  }, [errorHandlerObj.hasError, errorHandlerObj.message]);

  if (
    !errorHandlerObj.hasError ||
    !errorHandlerObj.message ||
    dismissedMessage === errorHandlerObj.message
  ) {
    return null;
  }

  return (
    <div
      className={`error-handler-container ${className || ""}`}
      role="alert"
      aria-live="polite"
    >
      <div className="error-handler-header">
        <div className="error-icon-wrrapper">
          <img src={errorIcon} alt="" />
        </div>
        <div className="error-handler-title">{errorHandlerObj.message}</div>

        <div className="cancel-error-buutton-wrrapper">
          <button
            type="button"
            aria-label="Dismiss error"
            onClick={() => setDismissedMessage(errorHandlerObj.message)}
          >
            <img src={cancelImg} alt="" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorHandler;
